<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Record</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('subtitle')" class="col-sm-4 col-form-label">Subtitle</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('subtitle')" v-model.lazy="subtitle">
        </div>
      </div>
      <div class="form-group form-row" v-if="hasExtraInfo">
        <label :for="safeId('extraInfo')" class="col-sm-4 col-form-label">Extra info</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('extraInfo')" v-model.lazy="extraInfo">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <album-select-group v-model="sponsorsAlbumId" label="Sponsors"></album-select-group>
      <album-select-group v-model="logosAlbumId" label="Logos"></album-select-group>
      <picture-select-group v-model="bottomLeftImageId" :album-id="logosAlbumId"
                            label="Bottom left image"></picture-select-group>
      <picture-select-group v-model="bottomRightImageId" :album-id="logosAlbumId"
                            label="Bottom right image"></picture-select-group>
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="datasetColumns">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternTitle')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternTitle')" v-model.lazy="patternTitle">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternSubtitle')" class="col-sm-4 col-form-label">Subtitle</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternSubtitle')" v-model.lazy="patternSubtitle">
        </div>
      </div>
      <div class="form-group form-row" v-if="hasExtraInfo">
        <label :for="safeId('patternExtraInfo')" class="col-sm-4 col-form-label">Extra info</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternExtraInfo')" v-model.lazy="patternExtraInfo">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapImageIdToImage, mapOverlayData, mapTemplateData, mapTemplateOptions } from '../../utils/index'
  import * as action from '@/store/action-types'

  export default {
    name: 'generic-lower-third',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['title', 'subtitle', 'extraInfo', 'bottomLeftImage', 'bottomRightImage']),
      ...mapTemplateData(['sponsorsAlbumId', 'datasetId', 'recordId']),
      ...mapTemplateData(['logosAlbumId', 'bottomLeftImageId', 'bottomRightImageId']),
      ...mapTemplateData({
        /* eslint-disable no-template-curly-in-string */
        patternTitle: {default: '${PLACE}'},
        patternSubtitle: {default: '${DATE}'},
        patternExtraInfo: {default: ''}
        /* eslint-enable no-template-curly-in-string */
      }),
      ...mapTemplateOptions(['hasExtraInfo']),
      dataset () {
        if (!this.datasetId) return null
        return this.$store.getters.dataset(this.datasetId)
      },
      datasetColumns () {
        if (!this.dataset) return
        return this.dataset.columns || []
      }
    },
    watch: {
      sponsorsAlbumId: function (val) {
        const album = this.$store.getters.album(val) || {}
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {sponsors: album.pictures}
        })
      },
      recordId: function (val) {
        if (!val) return
        let record = this.$store.getters.dataset(this.datasetId).records
          .find(r => r.recordId === val)
        if (!record) return
        record = this.mapRecord(record)
        this.title = record.title
        this.subtitle = record.subtitle
        this.extraInfo = record.extraInfo
      },
      ...mapImageIdToImage('logosAlbumId', 'bottomLeftImageId', 'bottomLeftImage'),
      ...mapImageIdToImage('logosAlbumId', 'bottomRightImageId', 'bottomRightImage')
    },
    methods: {
      mapRecord (record) {
        const result = {}
        const recordMap = {
          title: this.patternTitle,
          subtitle: this.patternSubtitle,
          extraInfo: this.patternExtraInfo
        }
        for (let k in recordMap) {
          if (!recordMap.hasOwnProperty(k)) continue
          result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
            return record[p1] || ''
          })
        }
        return result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/generic-lower-third.vue